import { nameValueArrayFromObject } from './utils.js';
export const guardianshipTypeDisplay = {
    NATURAL: 'Natural',
    LEGAL: 'Legal',
    NON_GUARDIAN: 'Non-guardian',
};
export function getGuardianshipTypeDisplay(guardianshipType) {
    const base = guardianshipTypeDisplay[guardianshipType];
    if (!base)
        return null;
    return guardianshipType === 'NON_GUARDIAN' ? base : `${base} guardian`;
}
export const guardianshipTypes = nameValueArrayFromObject(guardianshipTypeDisplay);
//# sourceMappingURL=guardianshipTypes.js.map